module.exports = __webpack_public_path__ + "assets/chevron-right.1f352cc1.svg";